/**
 * Sets block data mobile background scroll to Scroll With Page when desktop is set to Parallax. Otherwise returns original data.
 */
export const convertParallaxForMobile = (blockData) => {
  const data = blockData;
  if (data?.desktop?.background?.scroll === "x") {
    data.mobile.background.scroll = "p";
  }

  return data;
};
